import Layout from "@/components/elements/Layout";
import Link from "next/link";

export default function NotFoundComponent() {
  return (
    <Layout title={"Page Not Found"} description={"lorem"}>
      <div className='z-50 flex flex-col items-center justify-center w-full max-w-6xl px-4 py-40 mx-auto 2xl:max-w-7xl'>
        <h1 className='text-9xl md:text-[16rem] text-transparent text-center font-bold bg-gradient-to-r from-yellow-1 to-red-1 bg-clip-text leading-tight'>
          404
        </h1>
        <p className='mb-8 text-2xl text-center text-white'>
          {`Page you're looking for is not available.`}
        </p>
        <Link legacyBehavior href={"/"} passHref>
          <a className='flex items-center justify-center w-64 p-4 text-lg font-bold text-white duration-300 ease-out border border-white rounded-lg hover:text-dark-2 hover:bg-white hover:opacity-90'>
            Back to Homepage
          </a>
        </Link>
      </div>
      <div className='shape transform left-0 top-0 -translate-x-[70%]'></div>
    </Layout>
  );
}
